import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  isAuthenticated: false,
  loading: true,
  profileComplete: null,
  profileCompleteChecked: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setProfileComplete: (state, action) => {
      state.profileComplete = action.payload;
      state.profileCompleteChecked = true;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.profileComplete = null;
      state.profileCompleteChecked = false;
    },
  },
});

export const { setUser, setLoading, setProfileComplete, logout } = authSlice.actions;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthLoading = (state) => state.auth.loading;
export const selectProfileComplete = (state) => state.auth.profileComplete;
export const selectProfileCompleteChecked = (state) => state.auth.profileCompleteChecked;
export const selectUser = (state) => state.auth.user;
export default authSlice.reducer;
